import React from 'react';
import { pxToRem } from '../../utils/dimensionConverter';
import { Icon } from '../common/icon';

const AlertInfo = ({ onClose, type, message, description, closeRef, className = '', iconName = 'info' }) => (
  <div className={`alert ${type} ${className}`}>
    <button onClick={() => onClose()} className='alert__close' ref={closeRef}>
      <Icon name='close' size={pxToRem(9)} />
    </button>
    <div className='alert__icon'>
      <Icon name={iconName} size={pxToRem(20)} />
    </div>
    <div className='alert__content'>
      <span className='alert__title'>{message}</span>
      <span className='alert__description'>{description}</span>
    </div>
  </div>
)

const AlertError = ({ type, message, description, onClose, closeRef, iconName = 'error' }) => {
  const iconType = iconName ? iconName : 'alert';
  return (
    <div className={`alert ${type}`}>
      <button onClick={() => onClose()} className='alert__close' ref={closeRef}>
        <Icon name='close' size={pxToRem(9)} />
      </button>
      <div className='alert__icon'>
        <Icon name={iconType} size={pxToRem(20)} />
      </div>
      <div className='alert__content'>
        <span className='alert__title'>{message}</span>
        <span className='alert__description'>{description}</span>
      </div>
    </div>
  )
};

const AlertSuccess = ({ type, message, description }) => (
  <div className={`alert ${type}`}>
    <div className='alert__icon'>
      <Icon name='valid-check' size={pxToRem(20)} />
    </div>
    <div className='alert__content'>
      <span className='alert__title'>{message}</span>
      <span className='alert__description'>{description}</span>
    </div>
  </div>
);

let currentToastRef = null;

export const Alert = (toast, message, description, type, position, closeRef, otherOptions) => {
  const alertComponent = (onClose) => (
    <>
      {type === 'info' && (
        <AlertInfo onClose={onClose} type={type} message={message} description={description} closeRef={closeRef} className={otherOptions?.className} iconName={otherOptions?.iconName} />
      )}
      {type === 'error' && (
        <AlertError
          onClose={onClose}
          type={type}
          message={message}
          description={description}
          closeRef={closeRef}
          iconName={otherOptions?.iconName}
        />
      )}
      {type === 'success' && (
        <AlertSuccess onClose={onClose} type={type} message={message} description={description} />
      )}
    </>
  );

  if (currentToastRef && document.querySelector(".alert")) {
    document.querySelector(".alert").parentNode.parentNode.remove()
    currentToastRef = null
  }

  currentToastRef = toast({
    position: position || 'top',
    isClosable: true,
    duration: otherOptions?.asyncCloseToastRef ? null : '5000',
    render: ({ onClose }) => {
      if (otherOptions?.asyncCloseToastRef) {
        otherOptions.asyncCloseToastRef.current = onClose;
      }
      return alertComponent(onClose);
    },
    onCloseComplete: () => {
      currentToastRef = null;
    },
  });

  return currentToastRef;
};
